<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='轮转表管理' url='/cycle/plan/stulist'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <SearchNormalText v-model='condition.truename' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.cardno' label='工号'></SearchNormalText>
          <ZPGLSearchDictItemSelect v-model='condition.section' label='科室' :dictid='this.$utils.DictEnum.section'></ZPGLSearchDictItemSelect>
          <ZPGLSearchDictItemSelect v-model='condition.stuyear' label='届别' :dictid='this.$utils.DictEnum.stuyear'></ZPGLSearchDictItemSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">轮转时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.monthdate" type="month" placeholder="轮转时间" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column prop="CPStuName" label="姓名" width="120">
            </el-table-column>
            <el-table-column prop="CPStuNo" label="工号">
            </el-table-column>
            <el-table-column prop="StuYearName" label="届别">
            </el-table-column>
            <el-table-column prop="SecName" label="轮转科室">
            </el-table-column>
            <el-table-column label="轮转时间" width="250">
              <template slot-scope="scope">
                {{scope.row.CPBeginDate|formatDate}} 至 {{scope.row.CPEndDate|formatDate}}
              </template>
            </el-table-column>
            <el-table-column prop="CPStatusName" label="状态" width="80">
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanSecList',
  data () {
    return {
      condition: {
        username: '',
        rolelevel: '',
        secid: '',
        truename: '',
        cardno: '',
        section: '',
        stuyear: '',
        monthdate: '',
        token: '',
        pageSize: 10,
        currentPage: 1,
        recordCount: 0,
        firstSearch: true
      },
      tableData: null,
      name: '',
      title: '',
      searchUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/List',
      loading: true
    }
  },
  filters: {
    formatDate (val) {
      var now = new Date(val)
      var y = now.getFullYear()
      var m = now.getMonth() + 1
      return y + '-' + (m < 10 ? '0' + m : m)
    }
  },
  methods: {
    // 调整每页显示数
    handleCurrentChange: function (val) {
      this.condition.firstSearch = false
      this.condition.currentPage = val
      this.$refs.btnSearch.Search()
    },
    // 分页操作
    handleSizeChange: function (val) {
      this.condition.firstSearch = false
      this.condition.pageSize = val
      this.condition.currentPage = 1
      this.$refs.btnSearch.Search()
    },
    Edit: function (row) {
      this.$router.push({name: 'PlanEdit', params: {id: row.CPID,name: this.name,cpstuid: this.condition.cpstuid}})
    },
    Delete: function (row) {
      var args = {
        id: row.CPID,
        token: this.condition.token
      }
      this.$utils.Delete(this.$utils.Url.zpgl + '/api/APICyclePlan/Delete', args, row.StuName, this.$refs.btnSearch.Search)
    }
  },
  mounted: function () {
    this.condition.token = sessionStorage.getItem('token')
    this.condition.username = sessionStorage.getItem('username')
    this.condition.rolelevel = sessionStorage.getItem('rolelevel')
    this.condition.secid = sessionStorage.getItem('secid')
    this.$refs.btnSearch.Search()
  }
}
</script>

<style>
</style>
